import React, { useCallback } from 'react'
import { PlusMinusWrap, ProductNr, ProductOutOfStock, ProductPrice, ProductTitle, ProductWrap } from './index.styled'
import Currency from '../../../../currency'
import { getPosPriceByIndex } from '../../../../../../helper'
import PlusMinus from '../../../CartItem/PlusMinus'
import { useLocalStorage } from '../../../../../../hooks/useLocalStorage'
import { getColorsForCart } from '../../../../../../helper/getColorsForCart'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'

const Product = React.memo(({ selected, item, index, orderType, category, onClick, onMouseOver, onClickPlus, onClickMinus, isDisabled }) => {
	const [touchPad] = useLocalStorage('touchPad', false)
	const { colorTheme } = useTheme()
	const isTopping = item.productType === 'TOPPING'
	const isMenu = item.productType === 'MENU'
	const isOutOfStock = item?.outOfStock
	const isProductDisabled = isOutOfStock || isDisabled
	const active = selected && !isOutOfStock
	const layout = (touchPad === true ? 'touchPad ' : '') + (active ? 'active ' : '') + (isTopping ? 'topping ' : '') + (isMenu ? 'menu ' : '') +
		(colorTheme === 'DARK' ? 'thinkBorder ' : '') + (isOutOfStock ? 'disabled' : '')
	const parentCategory = category?.parent
	const colorCategory = parentCategory ? parentCategory?.colorData?.color : category?.colorData?.color
	const themeCategory = parentCategory ? parentCategory.colorData?.theme : category?.colorData?.theme
	const themeStyles = getColorsForCart(colorCategory, themeCategory, colorTheme, touchPad)
	const { t } = useTranslation()

	const handleClick = useCallback(e => {
		if (isProductDisabled) return
		onClick(e, item, index)
	}, [item, index, onClick, isProductDisabled])

	const handleMouseOver = useCallback(e => {
		if (isProductDisabled) return
		onMouseOver(index)
	}, [index, onMouseOver, isProductDisabled])

	const handlePlusClick = useCallback(e => {
		if (isProductDisabled) return
		onClickPlus(e, item, index)
	}, [item, index, onClickPlus, isProductDisabled])

	const handleMinusClick = useCallback(e => {
		onClickMinus(e, item, index)
	}, [item, index, onClickMinus])

	return (
		<ProductWrap className={layout + ' product-wrapper'}
								 themeStyles={themeStyles}
								 tabIndex={10 + index}
								 onClick={handleClick}
								 onMouseOver={handleMouseOver}>
			<ProductNr className={layout + (!item.nr ? ' empty' : '')}>{item.nr}</ProductNr>
			<ProductTitle className={layout}>{item.title}</ProductTitle>
			{isOutOfStock && !touchPad && <ProductOutOfStock className={layout}>{t('Cart.out_of_stock_product')}</ProductOutOfStock>}
			<ProductPrice className={layout}>
				<div><Currency>{getPosPriceByIndex(item, orderType, 0)?.value}</Currency></div>
				<PlusMinusWrap className={layout}>
					<PlusMinus {...{
						onClickPlus: handlePlusClick, onClickMinus: handleMinusClick,
						incrementAbility: true, removeAbility: isTopping, outline: isTopping
					}} />
				</PlusMinusWrap>
			</ProductPrice>
			{isOutOfStock && touchPad && <ProductOutOfStock className={layout}>{t('Cart.out_of_stock_product')}</ProductOutOfStock>}
		</ProductWrap>
	)
})

Product.displayName = 'Product'
export default Product
